import { types } from "./types/types";


const initialState = {
    polizas: [],
    loadingPolizas: false,
    checkingPolizas: true
};

export const poliza = (state = initialState, action) => {
    switch (action.type) {
        case types.setPoliza:
            return {
                ...state,
                polizas: action.payload
            }
        case types.startloadingSetPolizas:
            return {
                ...state,
                loadingPolizas: true
            }
        case types.finishloadingSetPolizas:
            return {
                ...state,
                loadingPolizas: false
            }
        default:
            return state;
    }
}